import PropTypes from 'prop-types';
import React from 'react';

export let DesignatedFundDonationBox = function ({ challengeId, submitDonation }) {
    const [showCustomAmountBox, setShowCustomAmountBox] = React.useState(false);
    const [showShowGiveAmounts, setShowGiveAmounts] = React.useState(false);
    const donationTier1Amount = 50;
    const donationTier2Amount = 100;
    const donationTier3Amount = 250;
    const donationTier4Amount = 500;
    const customAmountRef = React.useRef(null);

    function toggleShowCustomGiveAmount() {
        setShowCustomAmountBox(!showCustomAmountBox);
    }

    function toggleShowGiveAmounts() {
        setShowGiveAmounts(!showShowGiveAmounts);
    }

    function submitDonationTier1() {
        submitDonation(donationTier1Amount);
    }

    function submitDonationTier2() {
        submitDonation(donationTier2Amount);
    }

    function submitDonationTier3() {
        submitDonation(donationTier3Amount);
    }

    function submitDonationTier4() {
        submitDonation(donationTier4Amount);
    }

    function submitCustomAmount() {
        const amount = customAmountRef.current?.value;
        if (!amount || isNaN(amount) || amount <= 0) {
            alert('Please enter a valid donation amount.');
        } else {
            submitDonation(amount);
        }
    }

    return (
        <div className='anchored-donation-container'>
            {isMobileDevice && !showShowGiveAmounts
                ? <button className='button-primary mobile-give' onClick={toggleShowGiveAmounts}>Give</button>
                : <div className='give-actions'>
                    {!showCustomAmountBox
                        ? <div className='donation-amounts'>
                            <button className='button-primary heap-fund-give js-monthly-selection' onClick={submitDonationTier1}>
                                <span className='num js-num'>${donationTier1Amount}</span>
                            </button>
                            <button className='button-primary heap-fund-give js-monthly-selection' onClick={submitDonationTier2}>
                                <span className='num js-num'>${donationTier2Amount}</span>
                            </button>
                            <button className='button-primary heap-fund-give js-monthly-selection' onClick={submitDonationTier3}>
                                <span className='num js-num'>${donationTier3Amount}</span>
                            </button>
                            <button className='button-primary heap-fund-give js-monthly-selection' onClick={submitDonationTier4}>
                                <span className='num js-num'>${donationTier4Amount}</span>
                            </button>
                        </div>
                        : ''
                    }
                    {!showCustomAmountBox
                        ? <span className='text-link' onClick={toggleShowCustomGiveAmount}>Give another amount</span>
                        : <div className='form-redux progress-bar-form'>
                            <div style={{ display: !showCustomAmountBox ? 'none' : 'flex' }} className='custom-amount-box'>
                                <input type='number' autoFocus className='donation-amount' aria-label='donation amount' ref={customAmountRef} />
                                <button className='button-primary' onClick={submitCustomAmount}>Give</button>
                                <button className='button-secondary' onClick={toggleShowCustomGiveAmount}>Cancel</button>
                            </div>
                        </div>
                    }
                </div>
            }
        </div>
    );
};

DesignatedFundDonationBox.propTypes = {
    challengeId: PropTypes.string.isRequired,
    submitDonation: PropTypes.func.isRequired,
};

DesignatedFundDonationBox = React.memo(DesignatedFundDonationBox);
